const a = {
  id: "ArkansasCash3",
  name: "Cash 3",
  style: {
    colorPrimary: "#00b1e9"
  }
};
export {
  a as default
};
